import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enjson from './locales/en.json'
import rujson from './locales/ru.json'
import uzjson from './locales/uz.json'

i18n
    .use( initReactI18next )
    .init( {
        resources: {
            en: {
                translation: enjson
            },
            ru: {
                translation: rujson
            },
            uz: {
                translation: uzjson
            }
        },
        lng: localStorage.getItem( 'preferedLanguage' ) || 'uz', // Set default language explicitly
        fallbackLng: 'uz',
        interpolation: {
            escapeValue: false
        }
    } )

export default i18n